<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="primary"
        block
        v-on="on"
      >
        Upload File
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Files"
      text="Upload File"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <helper-file-input
                v-model="file" 
                v-validate="'required'" 
                :max-size-in-mb="50"
                :max-number="5"
                :multiple="true"
                data-vv-name="files"
                field-name="files"
                accept-type=".png,.jpg,.jpeg,.xlsx,.pdf,.docx,.csv,.xls,.doc,.mp4,.mkv,.webm"
                extension="ext:png,jpg,jpeg,xlsx,pdf,docx,csv,xls,doc,mp4,mkv,webm"          
              >
                <div 
                  slot="activator"
                  class="mb-2"
                >   
                  <v-btn                    
                    :disabled="progressing"
                    class="mx-2"    
                  >
                    Add file
                  </v-btn>
                  <span> 
                    {{ file ? '' : 'No file chosen (.png, .jpg, .jpeg, .pdf, .doc, .docx, .xls, .xlsx, .csv, .mp4, .mkv, .webm only)' }}
                  </span>
                  <div
                    v-if="file"
                    class="mt-4"
                  >
                    <p
                      v-for="selectedFile in file.selectedFiles"
                      :key="selectedFile.name"
                      class="mb-0"
                    >
                      <span class="font-weight-bold pl-2">{{ selectedFile.name }}</span>
                    </p>
                  </div>
                </div>
              </helper-file-input>
              <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Upload
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    components: {
      HelperFileInput: () => import('@/components/helper/FileInput'),
    },
    props: {
      parent: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        dialog: null,
        file: null,
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return this.$resetData()
      },
    },

    methods: { 
      prepareFormData () {
        if (this.file) {
          this.file.formData.set('parent', this.parent.id)
          this.file.formData.set('department_id', this.parent.department)
          this.file.formData.set('is_private', this.parent.is_private)

          return this.file.formData
        }
      },   
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true
    
            this.$api.myQualityManagement().upload(this.prepareFormData())
              .then((res) => {
                this.$emit('uploaded', res.data)                
                this.$snack({ message: 'Uploaded successfully' })

                this.progressing = false
                this.dialog = false
              })
              .catch(() => {
                this.progressing = false
              })
          })
      },

    },
  }
</script>
